import React from 'react';
import { content } from '../content';
import { ArrowRightIcon, QuoteIcon } from './Icon';
// `.panel` is shared with the sections.
import '../styles/Sections.css';
import '../styles/Testimonials.css';

const { testimonials } = content;

/** A hand-typed href should not be able to blank the page. */
const hostOf = (href: string) => {
  try {
    return new URL(href).hostname.replace(/^www\./, '');
  } catch {
    return href;
  }
};

/**
 * "2026-08" → "август 2026". Stored absolute and rendered absolute: a review
 * labelled "5 дней назад" is out of date the week after it is written, and a
 * stale relative date makes recent work look old.
 */
const monthOf = (iso: string) => {
  const date = new Date(`${iso}-01T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return null;

  return date
    .toLocaleDateString('ru-RU', { month: 'long', year: 'numeric', timeZone: 'UTC' })
    .replace(/\s*г\.$/, '');
};

/**
 * Its own section in the nav, not a strip under the project grid: two real
 * quotes are the strongest thing on this site, and they sit next to the
 * decision rather than next to the work.
 *
 * Renders nothing while `content.testimonials.items` is empty — the nav drops
 * the entry too, so the section is unreachable rather than empty. A made-up
 * quote reads worse than either.
 */
const Testimonials = () => {
  if (testimonials.items.length === 0) return null;

  return (
    <div className="section">
      <ul className="reviews">
        {testimonials.items.map((item) => (
          <li key={item.author + item.text.slice(0, 16)} className="review">
            <QuoteIcon size={22} className="review__mark" />
            <blockquote className="review__text">{item.text}</blockquote>
            <footer className="review__by">
              {/* Who and when on one line, what was delivered on the next:
                  the role line is a sentence, not a tag, and wrapping it
                  alongside the name left both unreadable. */}
              <span className="review__who">
                <span className="review__author">{item.author}</span>
                {item.date && monthOf(item.date) && (
                  <time className="review__date" dateTime={item.date}>
                    {monthOf(item.date)}
                  </time>
                )}
              </span>
              <span className="review__role">{item.role}</span>
              {item.href && (
                <a
                  className="review__link"
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {hostOf(item.href)}
                  <ArrowRightIcon size={13} />
                </a>
              )}
            </footer>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Testimonials;
